import Utils from "../util/Utils"

export function ActiveTab(props){
    const {selectedType,viewonly,callback,source} = props
    const filters = ['LCL', 'FCL', 'Air']
    const shipmentTypes = source !== "spot" ? Utils.getAuthProductList(filters) : filters
    return <div className="w-full h-[40px] bg-blue-dark rounded-t-md flex flex-row">
        {shipmentTypes.map((type,i)=><div onClick={()=>{
            if(!viewonly){
                callback(type)
            }
        }} className={` h-full text-white font-bold text-[18px] flex items-center justify-center w-[80px] uppercase hover:cursor-pointer ${type==="LCL" && "rounded-tl-md"} ${type===selectedType && "bg-yellow"}`}>{type}</div>)}
    </div>
}

export function ActiveTabCH(props){
    const {selectedType,viewonly,callback} = props
    const filters = ['LCL', 'FCL', 'Air']
    const shipmentTypes = filters
    return <div className="w-full h-[40px] rounded-t-md flex flex-row b--black">
        {shipmentTypes.map((type,i)=><div onClick={()=>{
            if(!viewonly){
                callback(type)
            }
        }} className={` h-full font-bold text-[18px] flex items-center justify-center w-[80px] uppercase hover:cursor-pointer ${type==="LCL" && "rounded-tl-md"} ${type===selectedType && "text-yellow"}`} style={{border:"1px solid"}}>{type}</div>)}
    </div>
}

export function ActiveTabCB(props){
    const {selectedType,viewonly,callback,source} = props
    const filters = ['FCL']
    const shipmentTypes = source !== "spot" ? Utils.getAuthProductList(filters) : filters
    return <div className="w-full h-[40px] bg-blue-dark rounded-t-md flex flex-row">
        {shipmentTypes.map((type,i)=><div onClick={()=>{
            if(!viewonly){
                callback(type)
            }
        }} className={` h-full text-white font-bold text-[18px] flex items-center justify-center w-[80px] uppercase hover:cursor-pointer ${type==="LCL" && "rounded-tl-md"} ${type===selectedType && "bg-yellow"}`}>{type}</div>)}
    </div>
}